import { DdplanOidcService } from './DdplanOidcService';
import { IipmOidcService } from './IipmOidcService';

export type AuthSystem = 'ddplan' | 'iipm';

export class OidcServiceFactory {
    private static ddplanService: DdplanOidcService | null = null;
    private static iipmService: IipmOidcService | null = null;

    /**
     * Get service ตาม auth_system ใน localStorage
     * ถ้าไม่มี auth_system จะใช้ ddplan เป็น default
     */
    public static getCurrentService(): DdplanOidcService | IipmOidcService {
        const authSystem = window.localStorage.getItem("auth_system") as AuthSystem;

        if (authSystem === 'iipm') {
            return this.getIipmService();
        } else {
            // default เป็น ddplan
            return this.getDdplanService();
        }
    }

    /**
     * Get service ตามระบบที่ระบุ
     */
    public static getService(system: AuthSystem): DdplanOidcService | IipmOidcService {
        if (system === 'iipm') {
            return this.getIipmService();
        } else {
            return this.getDdplanService();
        }
    }

    /**
     * Get DDPLAN service (Singleton)
     */
    public static getDdplanService(): DdplanOidcService {
        if (!this.ddplanService) {
            this.ddplanService = new DdplanOidcService();
        }
        return this.ddplanService;
    }

    /**
     * Get IIPM service (Singleton)
     */
    public static getIipmService(): IipmOidcService {
        if (!this.iipmService) {
            this.iipmService = new IipmOidcService();
        }
        return this.iipmService;
    }

    /**
     * Reset all services (ใช้เมื่อ logout)
     */
    public static resetServices(): void {
        this.ddplanService = null;
        this.iipmService = null;
    }

    /**
     * Check ว่า login อยู่หรือไม่
     */
    public static async isAuthenticated(): Promise<boolean> {
        try {
            const service = this.getCurrentService();
            const user = await service.getUser();
            return !!user && !this.isTokenExpired(user);
        } catch (error) {
            return false;
        }
    }

    /**
     * ตรวจสอบว่า token หมดอายุหรือไม่
     */
    private static isTokenExpired(user: any): boolean {
        if (!user || !user.expires_at) return true;
        return user.expires_at < Date.now() / 1000;
    }

    /**
     * Get current auth system
     */
    public static getCurrentAuthSystem(): AuthSystem {
        const authSystem = window.localStorage.getItem("auth_system") as AuthSystem;
        return authSystem || 'ddplan'; // default ddplan
    }
    /**
     * Get login path ตามระบบปัจจุบัน
     */
    public static getLoginPath(): string {
        const authSystem = window.localStorage.getItem("auth_system") as AuthSystem;

        if (authSystem === 'iipm') {
            return '/iipm';
        } else {
            return '/';
        }
    }

    /**
     * Get home path ตามระบบปัจจุบัน
     */
    public static getHomePath(): string {
        const authSystem = window.localStorage.getItem("auth_system") as AuthSystem;

        if (authSystem === 'iipm') {
            return '/home';
        } else {
            return '/organization';
        }
    }

    /**
     * Logout และ redirect ไปหน้า login ที่ถูกต้อง
     */
    public static async logout(history: any): Promise<void> {
        const authSystem = window.localStorage.getItem("auth_system") as AuthSystem;
        const service = this.getCurrentService();

        try {
            await service.logout();
            this.resetServices();

            // Redirect ตามระบบ
            if (authSystem === 'iipm') {
                history.push('/iipm');
            } else {
                history.push('/');
            }
        } catch (error) {
            console.error('Logout error:', error);
            // Force redirect แม้มี error
            if (authSystem === 'iipm') {
                history.push('/iipm');
            } else {
                history.push('/');
            }
        }
    }
}